<mat-toolbar  *ngIf="!fetchingEntries && showTable">
  <button mat-icon-button color="warn" (click)="openDeleteDialog(null)" [disabled]="!hasSelection()" *ngIf="[appPermissions.deleteData,permissionsActions.edit] | builderPermissions"><mat-icon>delete</mat-icon></button>
  <span>{{entityDetails?.entityName | titlecase}} data</span>
  <span class="example-spacer"></span>
</mat-toolbar>

@if( !fetchingEntries && showTable ){
  <div class="table-container">
  <table mat-table [dataSource]="dataSource" *ngIf="!fetchingEntries" >
  
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">

      <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: column }"></ng-container>
    </th>
      <td mat-cell *matCellDef="let entry; let i = index">
        <ng-container *ngIf="editRowIndex === i; else viewMode">
          <input class="form-control form-control-sm" *ngIf="getFieldIndex(editedEntry, column) !== -1" [(ngModel)]="editedEntry.entity_values_json[getFieldIndex(editedEntry, column)].value">
          <span *ngIf="getFieldIndex(editedEntry, column) === -1">N/A</span>
        </ng-container>
        <ng-template #viewMode>
          <ng-container *ngIf="getFieldValue(entry, column) as value">
            <span [matTooltip]="value.length > 20 ? value : '' ">{{ value | truncate:20 }}</span>
          </ng-container>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <div class="d-flex justify-content-center">
          <mat-checkbox (change)="toggleSelectAll($event)" [checked]="isAllSelected()" [indeterminate]="isPartialSelection()"></mat-checkbox>
         
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox 
        [(ngModel)]="selectedRows[row.submission_id]" 
        (ngModelChange)="updateSelection(row.submission_id, $event)">
      </mat-checkbox>
      </td>
    </ng-container>
  
    
  @if(([appPermissions.editData,permissionsActions.edit] | builderPermissions) || ([appPermissions.deleteData,permissionsActions.edit] | builderPermissions)){
    <ng-container matColumnDef="actions(E/D)">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let entry; let i = index">
        <ng-container *ngIf="editRowIndex === i; else viewMode">
         <div class="d-flex gap-1">
          <button mat-icon-button class="text-success" (click)="saveEdit()"><mat-icon >check</mat-icon></button>
          <button mat-icon-button color="warn" (click)="cancelEdit()"><mat-icon >close</mat-icon></button>
         </div>
        </ng-container>
        <ng-template #viewMode>
          <div class="d-flex gap-1">
            <button mat-icon-button color="primary" (click)="editRow(i, entry)" *ngIf="[appPermissions.editData,permissionsActions.edit] | builderPermissions"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button color="warn" (click)="openDeleteDialog(i)" *ngIf="[appPermissions.deleteData,permissionsActions.edit] | builderPermissions"><mat-icon>delete</mat-icon></button>
          </div>
        </ng-template>
      </td>
    </ng-container>
  }

    <tr mat-header-row *matHeaderRowDef="displayedColumnsWithActions;  sticky: true" ></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsWithActions;"></tr>
    <!-- Bulk Delete Button -->
  </table>
</div>
  <mat-paginator *ngIf="!fetchingEntries" [length]="totalItems" 
  [pageSize]="pageSize"   
  [pageIndex]="currentPage"
  [pageSizeOptions]="[10, 15,20, 25, 50,100]" 
  (page)="onPageChange($event)">
</mat-paginator>
  
}@else if(showNoData && !fetchingEntries){
  <div class="no-data">
    <p>No data found</p>
  </div>
}
  <!-- <div class="d-flex justify-content-center"> -->
    <vl-spinner [id]="'table-entity-data'"  [show]="fetchingEntries"></vl-spinner>
  <!-- </div> -->


<ng-template #headerTemplate let-column>
  <span [matTooltip]="column?.length > 20 ? column : '' " class="truncate-text"> {{ column | titlecase | truncate: 20 }} </span>
</ng-template>

<!-- Delete Confirmation Dialog Template -->
<ng-template #deleteConfirm let-data let-dialogRef="dialogRef" >
  <h2 mat-dialog-title>Confirm Delete</h2>
  <mat-dialog-content>
    <p>Are you sure you want to delete {{data ? 'this item' : 'these items'}}?</p>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-button (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button color="warn" (click)="dialogRef.close(true)">Delete</button>
  </mat-dialog-actions>
</ng-template>